module.exports = __webpack_public_path__ + "static/img/Modul.e8c5b823.jpg";